






















import { mapFields } from 'vuex-map-fields'
import ToggleThreeState from '@/components/ToggleThreeState.vue'

export default
    components: { ToggleThreeState }

    data: ->
        last_open_route: @$route.matched[0]?.path or 'details'
        options_series: ['M', 'B', 'S']

    computed: {
        tabs: ->
            tabs = @$store.state.tabs
            if @$route.path == '/' # filter out the "close" tab
                {close, others...} = tabs
                return others
            else # filter out the "open" tab
                {open, others...} = tabs
                return others
        current_tab: ->
            if @$route.matched.length > 0
                return @$route.matched[0].name
        ...mapFields('display', {
            'movies_or_series'
        })
    }

    methods:
        selectTab: (path) ->
            if path == 'close'
                @last_open_route = @$route.path
                @$router.push('/')
                return
            if path == 'open'
                @$router.push({path: @last_open_route})
                return
            @$router.push({path: "/" + path})

